import { render, staticRenderFns } from "./CentersCrudNotices.vue?vue&type=template&id=5731f6c2&"
import script from "./CentersCrudNotices.vue?vue&type=script&lang=js&"
export * from "./CentersCrudNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports